import type { EntraLoginResponse } from '../types/serviceType';
import { LOGIN_KIND, type User } from '../types/userType';

export const isEntraIdUser = (user: User | null | undefined): boolean => {
  return user?.loginKind === LOGIN_KIND.ENTRA_ID;
};

export const mapEntraLoginResponseToUser = (response: EntraLoginResponse | null | undefined): User => {
  const chaveM = String(response?.chaveM ?? '').trim();
  const emailFromField = String(response?.email ?? '').trim();
  const legacyIdentifier = String(response?.cpf ?? '').trim();
  const email = emailFromField || (legacyIdentifier.includes('@') ? legacyIdentifier : '');
  const resolvedChaveM = chaveM || (!email ? legacyIdentifier : '');

  return {
    loginKind: LOGIN_KIND.ENTRA_ID,
    chaveM: resolvedChaveM || undefined,
    email: email || undefined,
  };
};

export const resolveUserDisplayName = (
  user: User | null | undefined,
  fallback = 'Usuário',
): string => {
  if (!user) {
    return fallback;
  }
  if (isEntraIdUser(user)) {
    return user.email?.trim() || user.chaveM?.trim() || 'Backoffice';
  }
  return user.pessoaFisicaResponse?.pessoaFisica?.nome?.trim() || fallback;
};
